import styled, { keyframes } from "styled-components";
import transition from "../../styles/transition";
import SpectralNestedBox from "../SpectralNestedBox";

export const Container = styled.div`
  position: relative;
`;

export const Grade = styled.div`
  ${transition.normal}

  position: absolute;
  top: -50%;
  width: 100%;
  margin-top: 4px;
  transform: translateY(-50%);
  text-align: center;
  font-size: var(--fs12);
  font-weight: 500;
  color: #647693;
  opacity: 0;

  strong {
    color: #221d3c;
    display: block;
    font-weight: 600;
    font-size: var(--fs32);
    line-height: 1.2em;
  }
`;

const valueSize = 88;
export const ValueWrapper = styled(SpectralNestedBox)<{
  color?: string;
  noHover?: boolean;
}>`
  ${transition.normal}

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: ${valueSize}px;
  height: ${valueSize}px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--fs30);
  font-weight: 600;
  color: #27292c;
  position: relative;
  overflow: hidden;
  border: 1px solid #e6ecf3;
  box-shadow: inset 0 0 0 0 ${({ color }) => color},
    0px 2px 16px rgba(0, 0, 0, 0.04);

  span {
    ${transition.normal}

    position: relative;
    transform: translateY(0);
    opacity: 1;
  }

  ${Grade} strong {
    color: ${({ color }) => color};
  }

  ${({ noHover, color }) =>
    !noHover &&
    `
    &:hover {
      box-shadow: inset 0 0 0 3px ${color},
        0px 2px 16px rgba(0, 0, 0, 0.04);

      span {
        transform: translateY(calc(${valueSize / 2}px + 100%));
        opacity: 0;
      }
      ${Grade} {
        top: 50%;
        opacity: 1;
      }
    }
  `}
`;

const selectorPadding = 10;
export const ValueSelector = styled.div<{
  progress: number;
  canvas: number;
  size: number;
  strokeWidth: number;
}>`
  position: absolute;
  left: 50%;
  ${({ strokeWidth, canvas, size }) => {
    const ratio = size / canvas;
    const selectorSize = Math.round((strokeWidth + selectorPadding) * ratio);
    return `
      top: ${size - selectorSize + selectorPadding / 2}px;
      // margin-top: -${selectorSize - (selectorSize - strokeWidth) / 2}px;
      margin-left: -${selectorSize / 2}px;
      width: ${selectorSize}px;
      height: ${selectorSize}px;
      border-radius: 50%;
      transform-origin: 50% -${size / 2 - selectorSize + selectorPadding / 2}px;
    `;
  }}
  ${({ progress }) => `transform: rotate(${(progress * 360) / 100 + 4}deg);`}

  box-shadow:
    inset 0 0 0 4px #F9F9FF,
    0 0 4px rgba(0, 0, 0, 0.04);
  border: 1px solid #dfe7f0;
`;

const gaugeAura = keyframes`
  from {
    transform: translateX(-50%) translateY(-50%) rotate(180deg);
    filter: blur(0);
  }
  to {
    transform: translateX(-50%) translateY(-35%) rotate(180deg);
    filter: blur(4px);
  }
`;

export const GradientContainer = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  transform-origin: center;
  transform: translateX(-50%) translateY(-50%) rotate(180deg);
  animation: ${gaugeAura} 3s cubic-bezier(0.8, 0, 0.9, 0.8) alternate infinite;
`;

export const ScoreCalculated = styled.span`
  font-size: var(--fs30);
`;
